import { TypographyOptions } from '@mui/material/styles/createTypography';

// Accessible fonts
const fontFamily = [
  'DM Sans',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');

// Typography settings with accessibility in mind
export const typography: TypographyOptions = {
  fontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  // Headings
  h1: {
    fontWeight: 700,
    fontSize: '2.5rem', // 40px
    lineHeight: 1.2, // 48px
    letterSpacing: '-0.01em',
  },
  h2: {
    fontWeight: 700,
    fontSize: '2rem', // 32px
    lineHeight: 1.2, // 38.4px
    letterSpacing: '-0.005em',
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.5rem', // 24px
    lineHeight: 1.2, // 28.8px
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.25rem', // 20px
    lineHeight: 1.2, // 24px
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.125rem', // 18px
    lineHeight: 1.2, // 21.6px
  },
  h6: {
    fontWeight: 600,
    fontSize: '1rem', // 16px
    lineHeight: 1.2, // 19.2px
  },
  // Body text
  subtitle1: {
    fontSize: '1.125rem', // 18px
    lineHeight: 1.5, // 27px
    fontWeight: 500,
  },
  subtitle2: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.57, // 22px
    fontWeight: 500,
  },
  body1: {
    fontSize: '1rem', // 16px
    lineHeight: 1.5, // 24px
  },
  body2: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.5, // 21px
  },
  // UI elements
  button: {
    fontSize: '0.875rem', // 14px
    fontWeight: 600,
    lineHeight: 1.75, // 24.5px
    textTransform: 'none', // Don't force uppercase for accessibility
    letterSpacing: '0.02em',
  },
  caption: {
    fontSize: '0.75rem', // 12px
    lineHeight: 1.5, // 18px
  },
  overline: {
    fontSize: '0.75rem', // 12px
    fontWeight: 500,
    lineHeight: 1.5, // 18px
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
};